"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReimbursementDetailsResponse = exports.UpdateReimbursementFormData = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class UpdateReimbursementFormData extends base_models_1.Serializable {
}
exports.UpdateReimbursementFormData = UpdateReimbursementFormData;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 0.3876, description: 'Charge tariff per kWh incl. VAT' }),
    tslib_1.__metadata("design:type", Number)
], UpdateReimbursementFormData.prototype, "chargingTariff", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: false, description: 'Automatic tariff update' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateReimbursementFormData.prototype, "automaticTariffUpdate", void 0);
class ReimbursementDetailsResponse extends base_models_1.Serializable {
}
exports.ReimbursementDetailsResponse = ReimbursementDetailsResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: false,
        description: 'Whether the customer currently has automatic tariff update',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    tslib_1.__metadata("design:type", Boolean)
], ReimbursementDetailsResponse.prototype, "hasAutomaticTariffUpdate", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: false,
        description: 'Commodity Exists',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    tslib_1.__metadata("design:type", Boolean)
], ReimbursementDetailsResponse.prototype, "commodityExists", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 0.23,
        description: 'Commodity Kwh Price',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ReimbursementDetailsResponse.prototype, "commodityKwhPrice", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 0.23,
        description: 'Current reimbursement rate',
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ReimbursementDetailsResponse.prototype, "reimbursementTariff", void 0);
